import { render, staticRenderFns } from "./OrderIntakeFormsBackoffice.vue?vue&type=template&id=4d1a4258"
import script from "./OrderIntakeFormsBackoffice.vue?vue&type=script&lang=js"
export * from "./OrderIntakeFormsBackoffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports